import InputA from "../../components/InputA/InputA";
import { parseStringFromServer, prittifyStringFromServer } from "../../services/TextConverter";
import { TagSelector } from "./tags/TagSelector";
import { TagDTO, TagType } from "../DTO/TagDTO";
import { EditFieldKind, GenericDTO, GenericEditField } from "../DTO/GenericDTO";
import { CanBeDisplayed } from "./materialView";
import Select from "./Select";
import FileManager from "./FileManager/FileManager";
import ItemDTO from "../DTO/ItemDTO";
import { useEffect, useState } from "react";
import { Status } from "./day/dayView";
import { ArrowLeft, ArrowRight, Edit, Plus, Trash, Type } from "react-feather";

import './EditField.scss'
import './TextAreaArray.scss'
import PropDTO from "../DTO/PropDTO";
import { CreateTimeStamp, DisplayDate } from "../../services/DateTime";
import mainservice from "../../services/MainService";
import { PaperOrientation, PaperSizes } from "./PaperSizes";
import InputB from "../../components/InputB/InputB";
import UniqueEventIdInput from "../../components/UniqueEventIdInput/UniqueEventIdInput";
import ItemPersonDTO from "../DTO/ItemPersonDTO";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { useTheme } from '@mui/material/styles';


export function EditField(props: {
  field: GenericEditField,
  patch: (mf: GenericEditField) => Promise<GenericEditField>,
  item: ItemPersonDTO | GenericDTO | ItemDTO,
  editMode: boolean,
  alwaysShow?: boolean,
  noEditButton?: boolean,
  rerenderParent?: () => void,
}) {
  const field = props.field;
  const [status, setStatus] = useState(Status.standard)
  const [fieldValue, setFieldValue] = useState(field.value)
  const [copyToClipBoardState, setCopyToClipBoardState] = useState(0)
  const canBeDisplayed = CanBeDisplayed(props.item.publishKind, field.scope);
  const theme = useTheme();
  console.log('field', field)
  if (field.kind === EditFieldKind.empty) {
    return <div className={`empty ${field.className || ''}`}></div>
  }
  if (field.kind === EditFieldKind.textAreaArray) {
    return <TextAreaArrays
      field={props.field}
      item={props.item}
    />
  }
  if (canBeDisplayed === -1) { return null; }
  if (!props.alwaysShow && (!(
      field.kind === EditFieldKind.textArea ||
      field.kind === EditFieldKind.tag ||
      field.kind === EditFieldKind.multitag ||
      field.kind === EditFieldKind.files
    ) && !props.editMode && (!fieldValue || fieldValue === ''))
  ) {
    return null;
  }
  if (field.kind === EditFieldKind.copyCustomerAddress || field.kind === EditFieldKind.copyPersonAddress || field.kind === EditFieldKind.copyLocationAddress) {
    let toCopy = props.item.getPrintAddress()
    return <h2 className='EditField EditFieldCopyLocationAddress'>
      {props.field.title}
      <Button
        onClick={() => {
          navigator.clipboard.writeText(toCopy)
          setCopyToClipBoardState(copyToClipBoardState + 1)
        }}
      >
        <ContentCopyIcon />
      </Button>
    </h2>
  }

  if (field.kind === EditFieldKind.check) {
    return <Box
      sx={{
        paddingTop: '24px',
        marginLeft: '8px',
      }}
    >
        <FormControlLabel
          control={<Checkbox 
            checked={fieldValue === '1'}
            onClick={() => {
              if (fieldValue === '1') {
                setFieldValue('0')
                props.patch({ ...field, ...{ value: '0' } });
              } else {
                setFieldValue('1')
                props.patch({ ...field, ...{ value: '1' } });
              }
            }}
          />}
          label={ field.title }
        />
    </Box>
  }
  if (field.kind === EditFieldKind.personNumber) {
    return <div className={`EditField EditFieldPersonNumber ${field.className || ''}`}>
      <label className='EditFieldLabel' style={{marginTop: '-16px', color: '#666'}}>{ field.title }</label>
      <InputB
        className='w100'
        value={(props.item as ItemPersonDTO).getPersonNumber() as string}
        returnVal={async (rv) => {
          
        }}
        disabled={true}
      />
    </div>
  }
  if (field.kind === EditFieldKind.checkTF) {
    return <Box
      sx={{
        paddingTop: '24px',
      }}
    >
        <FormControlLabel
          control={<Checkbox 
            checked={fieldValue === 'T'}
            onClick={() => {
              if (fieldValue === 'T') {
                setFieldValue('F')
                props.patch({ ...field, ...{ value: 'F' } });
              } else {
                setFieldValue('T')
                props.patch({ ...field, ...{ value: 'T' } });
              }
            }}
          />}
          label={ field.title }
        />
    </Box>
  }
  const tagMode = ((field.kind === EditFieldKind.tag || field.kind === EditFieldKind.multitag) && (props.item instanceof GenericDTO || props.item instanceof ItemDTO))
  return <div className={`EditField w3-col flex flex-column ${props.editMode ? '' : ''} ${field.className || ''}`}>
    { !tagMode &&
      <label className='EditFieldLabel' style={{marginTop: '0', color: '#666'}}>
        { field.kind !== EditFieldKind.files && field.title }
        { field.kind === EditFieldKind.textArea &&
          <span className='labelTools'>
            { fieldValue &&
              <>
                <Button
                  sx={{
                    height: '8px',
                    marginLeft: '-16px',
                  }}
                >
                  <ContentCopyIcon
                    sx={{
                      height: '16px',
                      color: '#666',
                    }}
                    onClick={(() => {
                      if (fieldValue) {
                        // navigator.clipboard.writeText(fieldValue)
                        copyToClip(fieldValue)
                        setCopyToClipBoardState(1)
                        setTimeout(() => {
                          setCopyToClipBoardState(0)
                        }, 1000)
                      }
                    })}
                  />
                </Button>
                <span
                  className={`copyToClipBoardButton copyToClipBoardButtonState-${copyToClipBoardState}`}
                >
                  Text in die Zwischenablage kopiert
                </span>
              </>
            }
          </span>
        }
        { field.emojiWhenFilled && field.description &&
          <span className='fontSize2' dangerouslySetInnerHTML={{__html: field.emojiWhenFilled}}></span>
        }
        
      </label>
    }
    {props.editMode && field.description &&
      <div
        className='fieldDescription'
      >{field.description || ''}</div>}
    {!props.editMode && (
      field.kind === EditFieldKind.number ||
      // field.kind === EditFieldKind.textArea ||
      field.kind === EditFieldKind.string
    ) &&
      <div className='textAreaPrint'>
        <span dangerouslySetInnerHTML={{ __html: parseStringFromServer(fieldValue || '') }}></span>
        <span>{field.unit || ''}</span>
      </div>}
    {
      field.kind === EditFieldKind.files && props.item instanceof GenericDTO &&
      <FileManager
        key={`EditFieldFileManager-${props.item.id}`}
        item={props.item}
        readMode={!props.editMode}
        title={field.title}
      />
    }
    { props.editMode && field.kind === EditFieldKind.string &&
      <InputB
        className="w3-margin-bottom"
        value={parseStringFromServer(fieldValue || '')}
        returnVal={async (rv) => {
          await props.patch({ ...field, ...{ value: rv } });
          setFieldValue(rv)
        }}
        disabled={!mainservice.loginService.user.rights.canWrite(field.key1, field.key2)}
      />
    }
    { props.editMode && field.kind === EditFieldKind.uniqueEventId &&
      <UniqueEventIdInput
        item={props.item}
        value={parseStringFromServer(fieldValue || '')}
        returnVal={async (rv) => {
          await props.patch({ ...field, ...{ value: rv } });
          setFieldValue(rv)
          /*
          field.value = rv
          if (props.rerenderParent) {
            props.rerenderParent()
          }
          */
        }}
        disabled={!mainservice.loginService.user.rights.canWrite(field.key1, field.key2)}
      />}
    { props.editMode && (field.kind === EditFieldKind.number || field.kind === EditFieldKind.time || field.kind === EditFieldKind.date) &&
      <InputB
        value={parseStringFromServer(fieldValue || '')}
        returnVal={async (rv) => {
          await props.patch({ ...field, ...{ value: rv } });
          setFieldValue(rv)
        }}
        type={EditFieldKind[field.kind] as 'date' | 'time' | 'number'}
        />}
    { field.kind === EditFieldKind.textArea &&
      <>
        {
          (status === Status.edit) ?
          <InputB
              value={parseStringFromServer(fieldValue || field.default ||'')}
              returnVal={async (rv: string) => {
                await props.patch({ ...field, ...{ value: rv } });
                setFieldValue(rv)
                setStatus(Status.standard)
              } }
              type={'wysiwyg'}
              className='w100'
          /> : <Box
            className='pointer'
            sx={{
              border: '1px solid #c4c4c4',
              padding: '8px',
              borderRadius: theme.shape.borderRadius,
              minHeight: '100px',
              marginBottom: '16px',
            }}
            dangerouslySetInnerHTML={{ __html: parseStringFromServer(fieldValue || field.default || '') }}
            onClick={() => {
              setStatus(Status.edit)
            }}
          ></Box>
          
        }
      </>
    }
    <OldInstance
      editMode={props.editMode}
      field={field}
      item={props.item}
      rerenderParent={(setValue) => {
        field.value = setValue
        setFieldValue(setValue)
        if (props.rerenderParent) {
          props.rerenderParent()
        }
        console.log('upProp setFieldValue', setValue, field)
        
      }}
    />
    { props.editMode && field.kind === EditFieldKind.dropDown &&
      <Select
        value={parseStringFromServer(fieldValue || '')}
        returnVal={(rv) => {
          props.patch({ ...field, ...{ value: rv } });
        }}
        options={field.options || []}
      />
    }
    { tagMode &&
      <TagSelector
        parentId={props.item.id}
        kind={field.key2 as TagType}
        mode={(field.kind === EditFieldKind.tag) ? 'single' : 'list'}
        selectedTags={props.item.getTagsByKind(field.key2 as TagType, field.key1)}
        selectTag={async (tag: TagDTO, single: boolean) => {
          console.log('rerender plz selectTag', props.rerenderParent)
          await props.item.setTag(tag, single, field.key1);
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        unsetTag={async (tag: TagDTO) => {
          await props.item.unsetTag(tag, field.key1);
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        readMode={!props.editMode}
      />
    }
  </div>;
}

function OldInstance(props: {
  editMode: boolean,
  field: GenericEditField,
  item: GenericDTO | ItemDTO,
  rerenderParent?: (setValue: string) => void,
}) {
  const field = props.field
  const item = props.item
  const editMode = props.editMode
  if (
    !(item instanceof GenericDTO) ||
    !editMode ||
    !(field.kind === EditFieldKind.string || field.kind === EditFieldKind.number || field.kind === EditFieldKind.textArea)
  ) { return null }
  const localPropId = item.localPropId(props.field.key1, props.field.key2)
  const upProp = item.getUpProp(props.field.key1, props.field.key2)
  // if upProp is null - there is no up to compare with
  console.log('upProp', localPropId, upProp)
  if (localPropId === -1 || upProp === null) { return null }
  return <>
    <Type className='hover-show-next' />
    <div className='hover-show-next-target'>
      {
        upProp &&
        <div>Wert aus Vorlage:
          <div className='w3-padding w3-border w3-margin-top w3-margin-bottom' dangerouslySetInnerHTML={{__html: parseStringFromServer(upProp.value1)}}>
          </div>
        </div>
      }
      {
        localPropId > -1 &&
        <button
          onClick={async () => {
            await item.removeProp(localPropId)
            if (props.rerenderParent) {
              props.rerenderParent(upProp?.value1 || '')
            }
          }}
        >Lokale Änderung verwerfen</button>
      }
    </div>
  </>
}

const StandardManuskriptText = parseStringFromServer(`<h2 styleEQUALMARKDOUBLEQUOTEMARKtextMINUSMARKalignDOUBLEPOINTMARK centerSEMICOLONMARKDOUBLEQUOTEMARK>Überschrift<SLASHMARKh2><p styleEQUALMARKDOUBLEQUOTEMARKtextMINUSMARKalignDOUBLEPOINTMARK centerSEMICOLONMARKDOUBLEQUOTEMARK>Text<SLASHMARKp><p styleEQUALMARKDOUBLEQUOTEMARKtextMINUSMARKalignDOUBLEPOINTMARK centerSEMICOLONMARKDOUBLEQUOTEMARK><br><SLASHMARKp>`)

export function TextAreaArrays(props: {
  field: GenericEditField,
  item: GenericDTO | ItemDTO,
}) {
  const item = props.item
  const [orders, setOrders] = useState(item.getProps('moderationCardSetOrder'))
  const [status, setStatus] = useState(Status.standard)
  function reloadOrders() {
    setOrders(item.getProps('moderationCardSetOrder'))
    setStatus(Status.standard)
  }
  useEffect(() => {
    reloadOrders()
  }, [props.item])
  if (status === Status.loading) {
    return null
  }
  return <div className='contentPart'>
    <div className='contentHeader'>
      <h2>Manuskripte</h2>
    </div>
    <div className='w3-padding'>
      <Button
        variant="contained"
        onClick={async () => {
          setStatus(Status.loading)
          const key2 = CreateTimeStamp()
          const name = DisplayDate(new Date())
          const newName = new Date().getTime() + ''
          await item.addProp('moderationCardSet', newName, StandardManuskriptText)
          await item.addProp('moderationCardSetOrder', key2, newName, name)
          await item.addProp('moderationCardPaperSize', key2, 'A4')
          reloadOrders()
        }}
      >+ Manusskript hinzufügen</Button>
      {
        orders.map(o => {
          const key2 = o.key2
          return <TextAreaArray
            key={`TextAreaArrays-order-${key2}`}
            field={props.field}
            item={item}
            order={o}
            trash={async () => {
              await item.removeProp(o.id)
              reloadOrders()
            }}
          />
        })
      }
    </div>
  </div>
}

export function TextAreaArray(props: {
  field: GenericEditField,
  item: GenericDTO | ItemDTO,
  order: PropDTO,
  trash: () => void,
}) {
  const key1 = 'moderationCardSet'
  const item = props.item
  const [order, setOrder] = useState(parseStringFromServer(props.order.value1).split(';').filter(o => o !== ''))
  const [page, setPage] = useState(0)
  const currentCardName = order[page]
  const [name, setName] = useState(parseStringFromServer(props.order.value2))
  // const [status, setStatus] = useState(Status.standard)
  const [editCard, setEditCard] = useState('')
  const [status, setStatus] = useState(Status.standard)
  const [cardPaperOrientation, setCardPaperOrientation] = useState(item.getPropV1('moderationCardPaperOrientation', props.order.key2) || 'landscape')
  async function addCard(index: number) {
    const newName = new Date().getTime() + ''
    await item.addProp(key1, newName, StandardManuskriptText)
    order.splice(index, 0, newName)
    await item.addProp(props.order.key1, props.order.key2, order.join(';'), name)
    setEditCard(newName)
    setPage(index)
  }
  async function remCard(o: string) {
    if (!window.confirm('Karte wirklich löschen?')) { return }
    const p = item.getProp(key1, o)
    if (p) {
      await item.removeProp(p.id)
      await item.addProp(props.order.key1, props.order.key2, order.filter(or => or !== o).join(';'))
      setEditCard(o + '-del')
      setPage(Math.min(order.length - 2, page))
      setOrder(parseStringFromServer(props.order.value1).split(';').filter(o => o !== ''))
    }
  }
  function increasePage () {
    setPage(Math.min(order.length - 1, page + 1))
  }
  function decreasePage() {
    setPage(Math.max(0, page - 1))
  }
  async function trash() {
    // if (!window.confirm('Dieses Deck wirklich löschen?')) { return }
    // if (window.confirm('Deck doch behalten?')) { return }
    // We have to delete everything
    // Remove every single entry
    for(let i = 0, m = order.length; i < m; i++) {
      let p = item.getProp(key1, order[i])
      if (p) {
        await item.removeProp(p.id)
      }
    }
    props.trash()
  }
  
  const cardContent = item.getPropV1(key1, currentCardName) || ''
  const cardPaperSize = item.getPropV1('moderationCardPaperSize', props.order.key2) || 'A4'
  
  return <div className='TextAreaArray'>
    <h2>
      {name} {status === Status.standard &&
        <>
          <Edit
            className='pointer'
            onClick={() => {
              setStatus(Status.editName)
            }}
          />
          <Trash
            className='pointer'
            onClick={trash}
          />
          <div>Format</div>
          <Select
            options={PaperSizes.map((ps) => {
              return {
                title: ps.name,
                value: ps.key
              }
            })}
            value={cardPaperSize}
            returnVal={(nv) => {
              item.addProp('moderationCardPaperSize', props.order.key2, nv)
            }}
          />
          <div>Ausrichtung</div>
          <Select
            options={PaperOrientation.map((ps) => {
              return {
                title: ps.name,
                value: ps.key
              }
            })}
            value={cardPaperOrientation}
            returnVal={(nv) => {
              item.addProp('moderationCardPaperOrientation', props.order.key2, nv)
              setCardPaperOrientation(nv)
            }}
          />
        </>
      }
    </h2>
    {
      status === Status.editName &&
      <InputA
        value={name}
        returnVal={async (rv) => {
          await item.addProp(props.order.key1, props.order.key2, order.join(';'), rv)
          setName(rv)
          setStatus(Status.standard)
        }}
      />
    }

    <div
      className={`flex`}
    >
      <div className={`leftButtons flex flex-column`}>
        <button onClick={() => { addCard(page) }}>
          <Plus />
        </button>
        {
          0 < page &&
          <button onClick={decreasePage}><ArrowLeft /></button>
        }
      </div>
      <div
        className={`TextAreaArrayItem flex-grow TextAreaArrayItem-${cardPaperOrientation}`}
      >
        <Edit
          className='pointer'
          onClick={() => {
            setEditCard(currentCardName)
          }}
        />
        <Trash
          className='pointer'
          onClick={async () => {
            remCard(currentCardName)
          }}
        />
        {
          (currentCardName === editCard) ?
          <InputA
            value={parseStringFromServer(cardContent || '')}
            returnVal={async (rv) => {
              await item.addProp(key1, currentCardName, rv)
              setEditCard('')
            }}
            type={'wysiwyg'} /> : <div className={`TextArearArrayItemCard ${cardPaperOrientation}`}>
              <div dangerouslySetInnerHTML={{__html: prittifyStringFromServer(cardContent || '')}}></div>
              <div className={`page-number`}>{page + 1}</div>
            </div>
          }
      </div>
      <div className={`rightButtons flex flex-column`}>
        <button onClick={() => { addCard(page + 1) }}>
          <Plus />
        </button>
        { page < order.length - 1 && order[page + 1] &&
          <button onClick={increasePage}><ArrowRight /></button>
        }
      </div>
    </div>
  </div>
}

function copyToClip(str: string): void {
  function listener(e: ClipboardEvent): void {
    e.clipboardData?.setData("text/html", str)
    e.clipboardData?.setData("text/plain", str)
    e.preventDefault()
  }

  document.addEventListener("copy", listener);
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
}
